import request from '../utils/request';

export default fields => request('/mdm/form-data', { params: { fields } });
